import createIcon from '../../createIcon';

/**
 * @component @name ModeStandby
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ5IDIgMiA2LjQ5IDIgMTJDMiAxNy41MSA2LjQ5IDIyIDEyIDIyQzE3LjUxIDIyIDIyIDE3LjUxIDIyIDEyQzIyIDYuNDkgMTcuNTEgMiAxMiAyWk0xMiAyMEM3LjU5IDIwIDQgMTYuNDEgNCAxMkM0IDcuNTkgNy41OSA0IDEyIDRDMTYuNDEgNCAyMCA3LjU5IDIwIDEyQzIwIDE2LjQxIDE2LjQxIDIwIDEyIDIwWk0xNSAxMkMxNSAxMy42NiAxMy42NiAxNSAxMiAxNUMxMC4zNCAxNSA5IDEzLjY2IDkgMTJDOSAxMC4zNCAxMC4zNCA5IDEyIDlDMTMuNjYgOSAxNSAxMC4zNCAxNSAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModeStandby = createIcon('ModeStandby', [
  [
    'path',
    {
      d: 'M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12Z',
      key: 'ushdes',
    },
  ],
]);

export default ModeStandby;
